import script from "./ImagesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagesPage.vue?vue&type=script&setup=true&lang=js"

import "./ImagesPage.vue?vue&type=style&index=0&id=faa1d372&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faa1d372"]])

export default __exports__